module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Map and Co-Ordinates")]), _vm._v(" "), _c('p', {
    staticClass: "m-t-lg m-b-lg"
  }, [_vm._v("\n    Search for an address or click on the map to place the marker if you are unable to find the location. Please click and drag the marker if it is not placed correctly.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Search Address")]), _vm._v(" "), _c('gmap-autocomplete', {
    ref: "autocomplete",
    staticClass: "form-control",
    attrs: {
      "disabled": (_vm.locationNotEditable && _vm.notAlwaysEditable),
      "placeholder": ""
    },
    on: {
      "place_changed": _vm.handleAddressChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', [_c('gmap-map', {
    ref: "map",
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom,
      "options": {
        streetViewControl: false
      }
    },
    on: {
      "click": _vm.handleLocationMarker
    }
  }, [(_vm.locationHasLatitudeAndLongitude) ? _c('gmap-marker', {
    attrs: {
      "position": {
        lat: _vm.latitude,
        lng: _vm.longitude
      },
      "draggable": true
    },
    on: {
      "dragend": _vm.handleLocationMarker
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Longitude")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.longitude
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Latitude")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.latitude
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7775f0d9"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/locations/Map.vue
// module id = 1043
// module chunks = 0